import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import axios from 'axios';
import { useState } from 'react';
function Vehicle() {
  const [data, setData] = useState([]);
  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL+'/api/Vehicles/GetVehicles').then((response) => {
      setData(response.data);
    }
    ).catch((error) => {
      console.error(error);
    });
  }
  , []); 

  return (
    <>
    
    <div className=" overflow-auto rounded flex justify-center flex-col">
    <div className="h-10 m-0 p-0 bg-slate-500 opacity-30 flex justify-between" style={{borderRadius:'4px'}}>
          <input type="text" className=" m-2" style={{borderRadius: '4px'}} placeholder="Search"/>
          
        </div>

        <div className='flex justify-between m-3'>
    <h1 className="text-2xl font-semibold text-gray-900 ">Vehicles</h1>
    <NavLink to="/vehicles/addvehicle">
            <button
                type="button"
                className="rounded-md bg-lime-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                >
                Add Vehicle
            </button>
            </NavLink>
    </div>
    <div className="overflow-auto relative right-0">
    <table className=" divide-gray-200  m-2 min-w-full ">
  <thead className="bg-gray-150">
    <tr>
      <th className=" px-2 py-3 text-center text-xs font-medium  uppercase tracking-wider border">
        ID
      </th>
      <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
        Vehicle Num
        </th>
      <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
        Chasis No
        </th>
      <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
        Engine No
        </th>
        <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
            Manufacturer
        </th>
        <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
            Maker Model
        </th>
        <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
            Vehicle Class
        </th>
        <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
            Fuel Type
        </th>
        <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
            Color
        </th>
      <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
        is Active
      </th> 
        <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
            Actions
        </th>
    </tr>
  </thead>
  <tbody className="bg-white divide-gray-200">
       {/* <tr>
      <td className=" py-4 whitespace-nowrap border text-center">
        1
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
       <NavLink to="/VehicleOverview" className="text-blue-600 hover:underline">
        AP16 KHV
        </NavLink>

      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        123456789
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        987654321
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      BharatBenz
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      2823C
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      Truck
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      Diesel
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      Blue
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        Yes
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        <NavLink to="/vehicle/editvehicle">
        <button
            type="button"
            className="rounded-md bg-lime-500 ml-2 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
            >
         <FaEdit/>
        </button>
        </NavLink>
        <button
            type="button"
            className="rounded-md bg-red-500 ml-2 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
            >
            <MdDelete/>
        </button>
        </td>
       </tr>
        <tr>
      <td className=" py-4 whitespace-nowrap border text-center">
        2
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
       <NavLink to="/VehicleOverview" className="text-blue-600 hover:underline">
        AP16 KHV146
        </NavLink>
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        123456789
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        987654321
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      Ashok Leyland
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      5525C
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      Truck
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      Diesel
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      Red
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        Yes
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        <NavLink to="/vehicle/editvehicle">
        <button
            type="button"
            className="rounded-md bg-lime-500 ml-2 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
            >
      <FaEdit/>
        </button>
        </NavLink>
        <button
            type="button"
            className="rounded-md bg-red-500 ml-2 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
            >
          <MdDelete/>
        </button>
        </td>
       </tr>
       <tr>
      <td className=" py-4 whitespace-nowrap border text-center">
        3
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        <NavLink to="/VehicleOverview" className="text-blue-600 hover:underline">
        AP16 KHV123 
        </NavLink>
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        123456789
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        987654321
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      Tata Motors 
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      PRIMA 2830.K/.TK SRT
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      Truck
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      Diesel
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
      White
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        Yes
      </td>
      <td className=" py-4 whitespace-nowrap border text-center">
        <NavLink to="/vehicle/editvehicle">
        <button
            type="button"
            className="rounded-md bg-lime-500 ml-2 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
            >
      <FaEdit/>
        </button>
        </NavLink>
        <button
            type="button"
            className="rounded-md bg-red-500 ml-2 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
            >  <MdDelete/>
        </button>
        </td>
       </tr> */}
        {data.map((item) => (
        <tr key={item.id}>
        <td className=" py-4 whitespace-nowrap border text-center">
          {item.id}
        </td>
        <td className=" py-4 whitespace-nowrap border text-center">
          <NavLink to="/vehicles/VehicleOverview" className="text-blue-600 hover:underline">
            {item.vehiclenumber}
            </NavLink>
        </td>
        <td className=" py-4 whitespace-nowrap border text-center">
          {item.chassisnumber}
        </td>
        <td className=" py-4 whitespace-nowrap border text-center">
          {item.enginenumber}
        </td>
        <td className=" py-4 whitespace-nowrap border text-center
        ">
          {item.manufacturer}
        </td>
        <td className=" py-4 whitespace-nowrap border text-center">
          {item.model}
        </td>
        <td className=" py-4 whitespace-nowrap border text-center">
          {item.vehicleclass}
        </td>
        <td className=" py-4 whitespace-nowrap border text-center">
          {item.fueltype}
        </td>
        <td className=" py-4 whitespace-nowrap border text-center">
          {item.color}
        </td>
        <td className=" py-4 whitespace-nowrap border text-center">
          {item.isactive ? 'Yes' : 'No'}
        </td>
        <td className=" py-4 whitespace-nowrap border text-center">
          <NavLink to="/vehicle/editvehicle">
            <button
              type="button"
              className="rounded-md bg-lime-500 ml-2 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
            >
              <FaEdit />
            </button>
          </NavLink>
          <button
            type="button"
            className="rounded-md bg-red-500 ml-2 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
          >
            <MdDelete />
          </button>
        </td>
      </tr>
        ))}
  </tbody>
</table>
</div>
</div>
   </>
  )
}

export default Vehicle